export default class Tixly {
	constructor() {
		document.addEventListener('DOMContentLoaded', () => {
			this.init();
		 });

	}

	init() {
		console.log( 'init tixly' );
		const tixIframe = document.createElement('iframe');
		tixIframe.src = 'https://tickets.mge.nl/nl/itix';
		tixIframe.style.display = 'none';
		tixIframe.style.width = '0';
		tixIframe.style.height = '0';
		tixIframe.style.border = '0';
		document.body.appendChild(tixIframe);

		const userButton = document.querySelector('.mge-user__toggle');
		const userDropdown = document.querySelector('.mge-user-dropdown');
		const basketButtons = document.querySelectorAll('.mge-basket__toggle');
		const basketDropdown = document.querySelector('.mge-basket-dropdown');

		if (!userButton || !userDropdown) {
			return;
		}

		document.body.appendChild(userDropdown);
		if (basketDropdown) {
			document.body.appendChild(basketDropdown);
		}

		const userNameDropdown = document.querySelector('.js-user-name');
		const cartCount = document.querySelector('.js-cart-count');
		const cartCountBasket = document.querySelector('.js-cart-count-basket');
		const cartItemsContainer = document.querySelector('.js-cart-items');
		const cartItemsContainerBasket = document.querySelector('.js-cart-items-basket');
		const actions = document.querySelector('.js-user-actions');
		const basketActions = document.querySelector('.js-basket-actions');

		// Keep track of which basket button was clicked (for repositioning)
		let activeBasketButton = null;

		// Helper function to position dropdown
		const positionDropdown = (button, dropdown) => {
			if (!button || !dropdown) return;

			const rect = button.getBoundingClientRect();
			const offset = 10;

			// Position dropdown below button
			// Right position is set in CSS (30px), so we only need to set top
			dropdown.style.top = (rect.bottom + offset) + 'px';
		};

		// Account toggle (Mijn MgE)
		userButton.addEventListener('click', (e) => {
			e.preventDefault();
			e.stopPropagation();

			// Close basket dropdown if open
			if (basketDropdown) {
				basketDropdown.classList.remove('open');
			}

			// Position and toggle account dropdown
			positionDropdown(userButton, userDropdown);
			userDropdown.classList.toggle('open');
		});

		// Basket toggles
		if (basketButtons.length > 0 && basketDropdown) {
			basketButtons.forEach((basketButton) => {
				basketButton.addEventListener('click', (e) => {
					e.preventDefault();
					e.stopPropagation();

					// Close account dropdown if open
					userDropdown.classList.remove('open');

					// Remember which button was clicked
					activeBasketButton = basketButton;

					// Position and toggle basket dropdown
					positionDropdown(basketButton, basketDropdown);
					basketDropdown.classList.toggle('open');
				});
			});
		}

		// Reposition dropdowns on scroll and resize
		let repositionRequestId = null;
		const repositionDropdowns = () => {
			// Use requestAnimationFrame for smooth repositioning during scroll
			if (repositionRequestId !== null) {
				cancelAnimationFrame(repositionRequestId);
			}

			repositionRequestId = requestAnimationFrame(() => {
				if (userDropdown.classList.contains('open')) {
					positionDropdown(userButton, userDropdown);
				}
				if (basketDropdown && basketDropdown.classList.contains('open')) {
					// Use the button that was clicked, or find the visible one
					const buttonToUse = activeBasketButton || Array.from(basketButtons)
						.filter(btn => {
							const rect = btn.getBoundingClientRect();
							return rect.width > 0 && rect.height > 0 &&
								   rect.top >= 0 &&
								   rect.left >= 0 &&
								   rect.bottom <= window.innerHeight &&
								   rect.right <= window.innerWidth;
						})
						.find(btn => {
							// Prefer button in nav-actions (desktop) over mobile nav
							return btn.closest('.nav-actions') !== null;
						}) || Array.from(basketButtons).find(btn => {
							const rect = btn.getBoundingClientRect();
							return rect.width > 0 && rect.height > 0;
						});

					if (buttonToUse) {
						positionDropdown(buttonToUse, basketDropdown);
					}
				}
				repositionRequestId = null;
			});
		};

		window.addEventListener('scroll', repositionDropdowns, { passive: true });
		window.addEventListener('resize', repositionDropdowns);

		// Close dropdowns when clicking outside
		document.addEventListener('click', (e) => {
			const isUserButton = userButton.contains(e.target);
			const isUserDropdown = userDropdown.contains(e.target);
			const isBasketButton = Array.from(basketButtons).some(btn => btn.contains(e.target));
			const isBasketDropdown = basketDropdown && basketDropdown.contains(e.target);

			if (!isUserButton && !isUserDropdown) {
				userDropdown.classList.remove('open');
			}

			if (basketDropdown && !isBasketButton && !isBasketDropdown) {
				basketDropdown.classList.remove('open');
			}
		});

		window.addEventListener('load', () => {
			tixIframe.contentWindow.postMessage('GetSession', 'https://tickets.mge.nl');
		});

		window.addEventListener('message', (event) => {
			console.log('event');
			console.log(event);
			if (event.origin !== 'https://tickets.mge.nl') return;
			if (!event.data) return;
			this.updateUI(event.data, userNameDropdown, cartCount, cartCountBasket, cartItemsContainer, cartItemsContainerBasket, actions, basketActions);
		});
	}

	updateUI(info, userNameDropdown, cartCount, cartCountBasket, cartItemsContainer, cartItemsContainerBasket, actions, basketActions) {
		const user = info.user;
		const order = info.order;

		if (userNameDropdown) {
			userNameDropdown.textContent = user ? user.name : 'Gast';
		}

		const count = order?.items?.length || 0;
		const countText = count + ' items';

		if (cartCount) {
			cartCount.textContent = countText;
		}
		if (cartCountBasket) {
			cartCountBasket.textContent = countText;
		}

		// Update account dropdown cart items
		if (cartItemsContainer) {
			cartItemsContainer.innerHTML = '';
			if (count > 0) {
				order.items.forEach((item) => {
					const div = document.createElement('div');
					div.className = 'mge-user__cart-item';
					div.textContent = item.name + ' – ' + item.details;
					cartItemsContainer.appendChild(div);
				});
			}
		}

		// Update basket dropdown cart items
		if (cartItemsContainerBasket) {
			cartItemsContainerBasket.innerHTML = '';
			if (count > 0) {
				order.items.forEach((item) => {
					const div = document.createElement('div');
					div.className = 'mge-user__cart-item';
					div.textContent = item.name + ' – ' + item.details;
					cartItemsContainerBasket.appendChild(div);
				});
			}
		}

		// Update account dropdown actions
		if (actions) {
			console.log( 'actions:' );
			console.log( actions );
			actions.innerHTML = '';
			if (user) {
				actions.innerHTML += `<a class="btn btn--secondary" role="button" target="_blank" aria-label="Mijn account" href="${info.profile}">Mijn account</a>`;
				actions.innerHTML += `<a class="btn btn--secondary" role="button" target="_blank" aria-label="Uitloggen" href="https://tickets.mge.nl/nl/logout">Uitloggen</a>`;
			} else {
				actions.innerHTML += `<a class="btn btn--secondary" role="button" aria-label="Inloggen" target="_blank" href="${info.profile}">Inloggen</a>`;
			}
		} else {
			console.log('no actions' );
		}

		// Update basket dropdown actions
		if (basketActions) {
			basketActions.innerHTML = '';
			if (count > 0) {
				basketActions.innerHTML += `<a class="btn btn--secondary" role="button" aria-label="Afrekenen" href="${order.url}">Afrekenen</a>`;
			}
		}
	}
}

